export const DAY_MONTH_YEAR_FORMAT = 'dd/MM/yyyy';

const normalizeDateFormat = (dateFormat) => (dateFormat || '').toString().trim().toLowerCase();

const getAgencyDateDisplayFormat = (travelAgency) =>
  normalizeDateFormat(travelAgency?.dateDisplayFormat);

export const isDayMonthYearDateFormat = (travelAgency) => {
  if (!travelAgency) return false;

  const configuredFormat = getAgencyDateDisplayFormat(travelAgency);
  return configuredFormat === normalizeDateFormat(DAY_MONTH_YEAR_FORMAT);
};

export const getPrimaryDateInputFormat = (travelAgency) =>
  isDayMonthYearDateFormat(travelAgency) ? 'DD/MM/YYYY' : 'MM/DD/YYYY';

export const getAllowedDateInputFormats = (travelAgency) => {
  const dayFirstFormats = ['DD/MM/YYYY', 'D/M/YYYY'];
  const monthFirstFormats = ['MM/DD/YYYY', 'M/D/YYYY'];

  return isDayMonthYearDateFormat(travelAgency)
    ? [...dayFirstFormats, ...monthFirstFormats]
    : [...monthFirstFormats, ...dayFirstFormats];
};

export const getDateLocaleForAgency = (travelAgency) =>
  isDayMonthYearDateFormat(travelAgency) ? 'en-GB' : 'en-US';
